module.exports = __webpack_public_path__ + "img/turn_icon_3.2627085e.png";